var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenshare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 15,
    viewBox: "0 0 16 15",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.875.75h12.25c.957 0 1.75.79297 1.75 1.75v7.875c0 .9844-.793 1.75-1.75 1.75h-4.8125l.27344.875h1.91406c.4648 0 .875.4102.875.875 0 .4922-.4102.875-.875.875h-7c-.49219 0-.875-.3828-.875-.875 0-.4648.38281-.875.875-.875h1.88672l.30078-.875h-4.8125c-.984375 0-1.75-.7656-1.75-1.75v-7.875c0-.95703.765625-1.75 1.75-1.75zm12.25 1.75h-12.25v6.125h12.25z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshare);
export default __webpack_public_path__ + "static/media/screenshare.8cefc06acd5fa81858d3f3124c0f152c.svg";
export { ForwardRef as ReactComponent };